import Icon from "@ant-design/icons";
import {
  _ManageTRESVG,
  _ManageUserAccount,
  _ReportsSVG,
} from "../assets/icons/_svg";
export const gensantourismLogo = require("../assets/splashcreen/gensan-and-tourism-logo.png");
export const gensanLogo = require("../assets/splashcreen/gensan-seal.webp");
export const tourismLogo = require("../assets/splashcreen/tourism-logo.png");
export const bgMobile = require("../assets/splashcreen/bg-for-mobile.png");
export const bgDesktop = require("../assets/splashcreen/bg-for-desktop.png");

const images = {
  bgMobile,
  bgDesktop,
  gensantourismLogo,
  gensanLogo,
  tourismLogo,
};

const ReportsSVG = (props) => <Icon component={_ReportsSVG} {...props} />;

const ManageTRESVG = (props) => <Icon component={_ManageTRESVG} {...props} />;

const ManageUserAccount = (props) => (
  <Icon component={_ManageUserAccount} {...props} />
);
const svg = {
  ReportsSVG,
  ManageTRESVG,
  ManageUserAccount,
};

export { images, svg };
